// removed by extract-text-webpack-plugin
module.exports = {"upload":"PhotoUploadLink__upload___3ycBj","upload-photo-icon":"PhotoUploadLink__upload-photo-icon___1-GgH"};